"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.austriaParkingStatusSchema = void 0;
const zod_1 = require("zod");
const rest_area_1 = require("./rest-area");
exports.austriaParkingStatusSchema = zod_1.z.object({
    id: zod_1.z.string(),
    version: zod_1.z.string().optional(),
    statusOriginTime: zod_1.z.string(),
    siteStatus: rest_area_1.SiteAvailabilityStatusSchema,
    openingStatus: rest_area_1.SiteOpeningStatusSchema,
    numberOfVacantParkingSpaces: zod_1.z.number().optional(),
    numberOfOccupiedParkingSpaces: zod_1.z.number().optional(),
    occupancyRate: zod_1.z.number().optional(),
});
//# sourceMappingURL=austria.js.map